
//Importaciones
import  React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import MainAppContext from '../../../../../../../../MainAppContext';

function Cause(props) {
    //Helpers
    const contextSite = useContext(MainAppContext);

    //Parametros de entrada.
    const {
        inputParam_RootCause = null,
        inputParam_IsPreSelected = null,
        inputParam_Index = null,
        inputParam_OnSelectCause = null,
        inputParam_SelectedCauses = null,
        inputParam_SelectedCausesExcedded = null,
    } = props;

    //Parametros de componente.
    const inputRef = useRef()

    //Funciones de componente.
    const onCauseClick = (selectedCauses, onSelectedCausesExcedded) => {
        // La marca sale de la selección (inputParam_IsPreSelected), no de la clase del DOM: cambiarla a mano
        // dejaba causas marcadas en pantalla que no estaban en la selección que se guarda.
        inputParam_OnSelectCause && inputParam_OnSelectCause(!inputParam_IsPreSelected, inputParam_RootCause.id, selectedCauses, onSelectedCausesExcedded);
    }

    //Render de componente.
    return <>
        {
            !contextSite.onlyObserver ?
            <div
                role="button"
                ref={inputRef}
                onClick={() => onCauseClick(inputParam_SelectedCauses, inputParam_SelectedCausesExcedded)}
                className={inputParam_IsPreSelected ? "selectedFishboneCause": ""}
                id={inputParam_RootCause.id}
                key={`root_causes_${inputParam_RootCause.text}_${inputParam_Index}`}>
                    {inputParam_RootCause.text}
                    <i style={{ fontSize: 16, verticalAlign: "middle"}} className={ `ms-Icon ms-Icon--ChevronRightMed` } ></i>
            </div>
            :
            <div
                role="button"
                ref={inputRef}
                className={inputParam_IsPreSelected ? "selectedFishboneCause": ""}
                id={inputParam_RootCause.id}
                key={`root_causes_${inputParam_RootCause.text}_${inputParam_Index}`}>
                    {inputParam_RootCause.text}
                    <i style={{ fontSize: 16, verticalAlign: "middle"}} className={ `ms-Icon ms-Icon--ChevronRightMed` } ></i>
            </div>
        }
    </>
}

///Proptypes
Cause.propTypes = {
    inputParam_Index: PropTypes.number.isRequired,
    inputParam_RootCause: PropTypes.object.isRequired,
    inputParam_IsPreSelected: PropTypes.bool.isRequired,
    inputParam_OnSelectCause: PropTypes.func.isRequired,
    inputParam_SelectedCauses: PropTypes.array.isRequired,
    inputParam_SelectedCausesExcedded: PropTypes.func.isRequired,
};

export default Cause;